<template>
  <article class="verifyCode" @click.stop="getCode">
    <div v-show="show" class="weui_loading_leaf" v-for="i in 12" :class="['weui_loading_leaf_' + (i-1)]"></div>
    <span>{{codeText}}</span>
  </article>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: {
        show: false,
        time: 60,
        start: false,
        codeText: ''
      }
    }
  },
  methods: {
    getCode() {
      if (this.interval !== null) {
        return false
      }
      this.$emit('on-getCode')
    },
    tick() {
      let seconds = this.time
      this.show = false
      this.codeText = `剩余: ${seconds} 秒`
      this.interval = setInterval(() => {
        if (seconds-- > 0) {
          this.codeText = `剩余: ${seconds} 秒`
        } else {
          this.stop()
        }
      }, 1000)
    },
    stop() {
      this.codeText = this.text
      clearInterval(this.interval)
      this.interval = null
      this.start = false
    }
  },
  watch: {
    'value.show' (val) {
      this.show = val
    },
    'value.time' (val) {
      this.time = val
    },
    'value.start' (val) {
      this.start = val
    },
    'value.codeText' (val) {
      this.codeText = val
    },
    show(val) {
      let options = {
        show: val,
        time: this.time,
        start: this.start,
        codeText: this.codeText
      }
      this.$emit('input', options)
    },
    codeText(val) {
      let options = {
        show: this.show,
        time: this.time,
        start: this.start,
        codeText: val
      }
      this.$emit('input', options)
    },
    time(val) {
      let options = {
        show: this.show,
        time: val,
        start: this.start,
        codeText: this.codeText
      }
      this.$emit('input', options)
    },
    start(newVal, oldVal) {
      if (newVal === true && oldVal === false && this.time > 0) {
        this.tick()
      }
      if (newVal === false && oldVal === true) {
        this.stop()
      }
      let options = {
        show: this.show,
        time: this.time,
        start: newVal,
        codeText: this.codeText
      }
      this.$emit('input', options)
    }
  },
  created() {
    this.show = this.value.show
    this.time = this.value.time
    this.start = this.value.start
    this.text = this.codeText = this.value.codeText
    if (this.start) {
      this.tick()
    }
  },
  data() {
    return {
      show: false,
      interval: null,
      time: 60,
      start: false,
      codeText: '',
      text: ''
    }
  }
}
</script>
<style scoped lang="less">
  @import '../../styles/cui/base/fn';
@import '../../styles/cui/widget/cui_tips/cui_toast';
@import '../../styles/cui/base/mixin/loading';
@width: 4.14/@w;
@height: 2.08/@w;
@transX: 3.5/@w;
.verifyCode {
  position: absolute;
  top: 150/@w2;
  right: 30/@w2;
  -webkit-appearance: none;
  appearance: none;
  font-size: 26/@w2;
  line-height: 53/@w2;
  padding: 0 30/@w2;
  text-align: center;
  background: #fff;
  color: #5890FF;
  border: 1px solid #5890FF;
  border-radius: 8/@w2;
}

.weui_loading_leaf{
  position: absolute;
  top: 45%;
  left: 15/@w2;
}
</style>



// WEBPACK FOOTER //
// verify-code.vue?0d8e7644